<p-toast position="bottom-center"></p-toast>
<sg-loading [visible]="IsVisible"></sg-loading>

<!-- ✨ Decoraciones navideñas (solo visible en temporada) -->
<div class="christmas-decorations" *ngIf="esTemporadaNavidad">
  <div class="snowflakes" aria-hidden="true">
    <div class="snowflake">❅</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
  </div>

  <div class="christmas-lights">
    <div class="light red"></div>
    <div class="light green"></div>
    <div class="light blue"></div>
    <div class="light yellow"></div>
    <div class="light red"></div>
    <div class="light green"></div>
    <div class="light blue"></div>
    <div class="light yellow"></div>
  </div>
</div>

<!-- Mensaje de contador de intentos fallidos -->
<div *ngIf="contadorFallas >= intentosMax" class="contador-container">
  <div>
    <p>Se ha alcanzado el número máximo de intentos.</p>
    Podrá volver a intentar en
    <label style="color: #3ba2dc; font-weight: bold">{{ relojText }}</label>
  </div>
</div>

<!-- ==================== CONTENEDOR PRINCIPAL (NO DEMO) ==================== -->
<div
  class="background blue contenedor"
  [ngClass]="{ 'christmas-theme': esTemporadaNavidad }"
  *ngIf="!esDemo"
>
  <div class="sub-contenedor">
    <!-- Logo circular superior -->
    <div
      class="contenedor-circular"
      [ngClass]="{ 'christmas-glow': esTemporadaNavidad }"
    >
      <img
        src="../../../../../../assets/svg/logoSigessRedondo.svg"
        decoding="async"
        alt="Logo SIGESS"
      />
      <div class="santa-hat" *ngIf="esTemporadaNavidad">🎅</div>
    </div>

    <!-- Contenedor del formulario con wrapper de glow -->
    <div
      class="glow-wrapper"
      [ngClass]="{ 'christmas-card': esTemporadaNavidad }"
    >
      <div
        class="contenedor-cuadrado ui-scaled"
        [ngClass]="{ 'christmas-layout': esTemporadaNavidad }"
      >
        <!-- Contenido del formulario -->
        <div
          class="form-content"
          [style.padding-top]="esTemporadaNavidad ? '85px' : '75px'"
          *ngIf="flag"
        >
          <!-- Formulario de login -->
          <form [formGroup]="formLogin" role="form">
            <mat-form-field appearance="outline" style="width: 74%">
              <mat-label>Correo electrónico</mat-label>
              <input
                id="asd"
                type="email"
                formControlName="correo"
                matInput
                autocomplete="on"
                (input)="
                  form
                    .get('correo')
                    ?.setValue($event.target.value.toLowerCase())
                "
              />
            </mat-form-field>

            <mat-form-field appearance="outline" style="width: 74%">
              <mat-label>Contraseña</mat-label>
              <input
                [type]="typePassword"
                matInput
                formControlName="password"
              />
              <mat-icon *ngIf="isPassword" matSuffix (click)="tooglePsw()"
                >visibility</mat-icon
              >
              <mat-icon *ngIf="!isPassword" matSuffix (click)="tooglePsw()"
                >visibility_off</mat-icon
              >
            </mat-form-field>

            <!-- Botón Ingresar -->
            <div>
              <button
                class="button-round button-gray text-color-white"
                *ngIf="formLogin.invalid"
                mat-raised-button
                color="disabled"
              >
                Ingresar
              </button>
              <button
                class="button-round button-orange"
                [ngClass]="{ 'christmas-button': esTemporadaNavidad }"
                *ngIf="formLogin.valid"
                (click)="validate(formLogin.value)"
                mat-raised-button
                color="primary"
              >
                Ingresar
              </button>
            </div>

            <br />

            <!-- Botones OAuth -->
            <div style="margin-bottom: 10px">
              <a
                class="btn btn-light border rounded-pill d-inline-flex align-items-center px-3"
                [ngClass]="{ 'christmas-oauth-button': esTemporadaNavidad }"
                [href]="googleLoginUrl"
              >
                <img
                  src="https://developers.google.com/identity/images/g-logo.png"
                  alt="Google logo"
                  width="20"
                  height="20"
                  class="me-2"
                />
                Iniciar con Google
              </a>
            </div>

            <div>
              <a
                class="btn btn-light border rounded-pill d-inline-flex align-items-center px-3"
                [ngClass]="{ 'christmas-oauth-button': esTemporadaNavidad }"
                [href]="microsoftLoginUrl"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
                  alt="Microsoft logo"
                  width="20"
                  height="20"
                  class="me-2"
                />
                Iniciar con Microsoft
              </a>
            </div>
          </form>

          <!-- Enlaces y footer del formulario -->
          <div
            class="form-footer"
            [style.margin-top]="esTemporadaNavidad ? '20px' : '40px'"
          >
            <p class="predec-link">
              ¿No puedes ingresar?
              <a class="link" routerLink="/reset-password"
                >Recordar Contraseña</a
              >
            </p>

            <div class="urlLer">
              <span>Desarrollado por: </span>
              <a
                href="https://lerprevencion.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  class="logo-ler" 
                  src="../../../../../../assets/png/NuevosLogos/LER_3.png"
                  alt="LER Prevención"
                />
              </a>
            </div>
          </div>
        </div>
        <!-- Fin contenido del formulario -->
      </div>
      <!-- Fin contenedor-cuadrado -->
    </div>
    <!-- Fin glow-wrapper -->
  </div>
  <!-- Fin sub-contenedor -->

  <div class="footer">
    <label class="version">v {{ version }}</label>
  </div>
</div>
<!-- ==================== FIN CONTENEDOR PRINCIPAL (NO DEMO) ==================== -->

<!-- ==================== CONTENEDOR DEMO ==================== -->
<div
  class="background yellow contenedor"
  [ngClass]="{ 'christmas-theme': esTemporadaNavidad }"
  *ngIf="esDemo"
>
  <div class="sub-contenedor">
    <!-- Logo circular superior -->
    <div
      class="contenedor-circular"
      [ngClass]="{ 'christmas-glow': esTemporadaNavidad }"
    >
      <img
        src="../../../../../../assets/svg/logoSigessRedondo.svg"
        alt="Logo SIGESS"
      />
      <div class="santa-hat" *ngIf="esTemporadaNavidad">🎅</div>
    </div>

    <!-- Contenedor del formulario con wrapper de glow -->
    <div
      class="glow-wrapper"
      [ngClass]="{ 'christmas-card': esTemporadaNavidad }"
    >
      <div
        class="contenedor-cuadrado ui-scaled"
        [ngClass]="{ 'christmas-layout': esTemporadaNavidad }"
      >
        <!-- Contenido del formulario -->
        <div
          class="form-content"
          [style.padding-top]="esTemporadaNavidad ? '85px' : '75px'"
          *ngIf="flag"
        >
          <!-- Formulario de login -->
          <form [formGroup]="formLogin" role="form">
            <mat-form-field appearance="outline" style="width: 74%">
              <mat-label>Correo</mat-label>
              <input
                id="asd"
                type="email"
                formControlName="correo"
                matInput
                autocomplete="off"
              />
            </mat-form-field>

            <mat-form-field appearance="outline" style="width: 74%">
              <mat-label>Contraseña</mat-label>
              <input
                [type]="typePassword"
                matInput
                formControlName="password"
              />
              <mat-icon *ngIf="isPassword" matSuffix (click)="tooglePsw()"
                >visibility</mat-icon
              >
              <mat-icon *ngIf="!isPassword" matSuffix (click)="tooglePsw()"
                >visibility_off</mat-icon
              >
            </mat-form-field>

            <!-- Botón Ingresar -->
            <div>
              <button
                class="button-round button-gray text-color-white"
                *ngIf="formLogin.invalid"
                mat-raised-button
                color="disabled"
              >
                Ingresar
              </button>
              <button
                class="button-round button-orange"
                [ngClass]="{ 'christmas-button': esTemporadaNavidad }"
                *ngIf="formLogin.valid"
                (click)="validate(formLogin.value)"
                mat-raised-button
                color="primary"
              >
                Ingresar
              </button>
            </div>

            <br />

            <!-- Botones OAuth -->
            <div style="margin-bottom: 10px">
              <a
                class="btn btn-light border rounded-pill d-inline-flex align-items-center px-3"
                [ngClass]="{ 'christmas-oauth-button': esTemporadaNavidad }"
                [href]="googleLoginUrl"
              >
                <img
                  src="https://developers.google.com/identity/images/g-logo.png"
                  alt="Google logo"
                  width="20"
                  height="20"
                  class="me-2"
                />
                Iniciar con Google
              </a>
            </div>

            <div>
              <a
                class="btn btn-light border rounded-pill d-inline-flex align-items-center px-3"
                [ngClass]="{ 'christmas-oauth-button': esTemporadaNavidad }"
                [href]="microsoftLoginUrl"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
                  alt="Microsoft logo"
                  width="20"
                  height="20"
                  class="me-2"
                />
                Iniciar con Microsoft
              </a>
            </div>
          </form>

          <!-- Enlaces y footer del formulario -->
          <div
            class="form-footer"
            [style.margin-top]="esTemporadaNavidad ? '20px' : '40px'"
          >
            <p class="predec-link">
              ¿No puedes ingresar?
              <a class="link" routerLink="/reset-password"
                >Recordar Contraseña</a
              >
            </p>

            <div class="urlLer">
              <span>Desarrollado por: </span>
              <a
                href="https://lerprevencion.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  class="logo-ler" 
                  src="../../../../../../assets/png/NuevosLogos/LER_3.png"
                  alt="LER Prevención"
                />
              </a>
            </div>
          </div>
        </div>
        <!-- Fin contenido del formulario -->
      </div>
      <!-- Fin contenedor-cuadrado -->
    </div>
    <!-- Fin glow-wrapper -->
  </div>
  <!-- Fin sub-contenedor -->

  <div class="footer">
    <label class="version">v {{ version }}</label>
  </div>
</div>
<!-- ==================== FIN CONTENEDOR DEMO ==================== -->

<p-confirmDialog
  appendTo="body"
  acceptLabel="Si"
  [style]="{ width: '50vw' }"
></p-confirmDialog>

<app-whatsapp></app-whatsapp>

<div *ngIf="showDialog" class="dialog-backdrop">
  <div class="custom-dialog">
    <h2>Acceso no autorizado</h2>
    <p>Este correo no está registrado en la plataforma.</p>
    <button (click)="closeDialog()">Entendido</button>
  </div>
</div>
<div *ngIf="showDialogUserActive" class="dialog-backdrop">
  <div class="custom-dialog">
    <h2>Acceso no autorizado</h2>
    <p>
      Este usuario no se encuentra activo, para usar el inicio de sesión por
      Google o Microsoft actualice su información.
    </p>
    <button (click)="closeDialog()">Entendido</button>
  </div>
</div>
